import AppMainScores from './app-main-scores';

export default AppMainScores;
